<script setup lang="ts">
import { scrollToTop } from '@utils/helpers';
import { computed, onUnmounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { pinItem, unpinItem } from '../sidebar-service/sidebar.service';

const linkRef = ref(null);
const route = useRoute();
const props = defineProps<{
    menuItem: string,
    disablePin?: string,
    unpin?: string
}>();

const isActive = computed(() => route.path.startsWith(props.menuItem));
const stop = watch(() => route.path, () => scrollToTop);

function toggleItem() {
    if (props.unpin == 'true') {
        unpinItem(props.menuItem);
        return;
    }

    pinItem(props.menuItem, linkRef?.value?.textContent?.trim() || '')
}

onUnmounted(stop);
</script>
<template>
    <li class="flex items-center" :class="{ 'active': isActive }" ref="linkRef">
        <router-link class="flex-grow" :to="menuItem">
            <slot />
        </router-link>
        <button @click="toggleItem" class="pin" v-if="!disablePin">
            <i class="fas" :class="{ 'fa-thumbtack-slash': unpin, 'fa-thumbtack': !unpin }"></i>
        </button>
    </li>
</template>